import { create } from 'zustand';
import { getItem, setItem, removeItem } from './storage';
interface LangState {
  locale: string | null;
  setLocale: (locale?: string) => void;
}

const useLangStore = create<LangState>((set) => ({
  locale: (() => {
    const cookieValue = getItem('locale');
    if (cookieValue === undefined || cookieValue === 'undefined') {
      return null;
    }
    try {
      return typeof cookieValue === 'string'
        ? cookieValue
        : JSON.stringify(cookieValue);
    } catch (error) {
      removeItem('locale'); // Clear the bad cookie
      // eslint-disable-next-line no-console
      console.log('Error parsing userData cookie:', error);
      return null;
    }
  })(),
  setLocale: (locale) => {
    setItem('locale', locale);
    set({ locale });
  },
}));

export default useLangStore;
